import * as React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMinusCircle, faPlusCircle } from '@fortawesome/pro-light-svg-icons';
import { preventKeyPress } from '../../utils';
import Button from './Button';
import { classNamesUtil } from '../../utils/classNamesUtil.util';

const DaysAmount = ({
  change,
  days,
  decrease,
  disableDecrease,
  disableIncrease,
  increase,
  onClickInput,
  withoutBorders,
}) => (
  <div className="amount-carousel">
    <Button
      colorBlank={!withoutBorders}
      colorClean={withoutBorders}
      containerClass={classNamesUtil('', {
        'amount-carousel__without-padding': withoutBorders,
      })}
      disabled={disableDecrease}
      icon={<FontAwesomeIcon icon={faMinusCircle} />}
      onClick={decrease}
    />
    {withoutBorders ? (
      <span className="label-m color-gray-800 spacer-horizontal-10">
        {days}
      </span>
    ) : (
      <input
        onChange={change}
        onClick={onClickInput}
        onKeyDown={preventKeyPress}
        placeholder="0"
        size={2}
        type="text"
        value={days || 0}
      />
    )}

    <Button
      colorBlank={!withoutBorders}
      colorClean={withoutBorders}
      containerClass={classNamesUtil('', {
        'amount-carousel__without-padding': withoutBorders,
      })}
      disabled={disableIncrease}
      icon={<FontAwesomeIcon icon={faPlusCircle} />}
      onClick={increase}
    />
  </div>
);

DaysAmount.propTypes = {
  change: PropTypes.func,
  days: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  decrease: PropTypes.func,
  disableDecrease: PropTypes.bool,
  disableIncrease: PropTypes.bool,
  increase: PropTypes.func,
  onClickInput: PropTypes.func,
  withoutBorders: PropTypes.bool,
};

export default DaysAmount;
